import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EditBillAmountData {
  billId: number;
  currentAmount: number;
  projectName: string;
}

@Component({
  selector: 'app-edit-bill-amount-dialog',
  templateUrl: './edit-bill-amount-dialog.component.html',
  styleUrls: ['./edit-bill-amount-dialog.component.css']
})
export class EditBillAmountDialogComponent {
  editForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditBillAmountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditBillAmountData
  ) {
    this.editForm = this.fb.group({
      amount: [data.currentAmount, [Validators.required, Validators.min(0)]],
      remark: ['', [Validators.required, Validators.minLength(5)]]
    });
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.editForm.valid) {
      const newAmount = parseFloat(this.editForm.value.amount);
      const remark = this.editForm.value.remark?.trim() || '';
      
      if (newAmount < 0) {
        return;
      }
      
      if (!remark || remark.length < 5) {
        this.editForm.get('remark')?.setErrors({ minlength: true });
        this.editForm.get('remark')?.markAsTouched();
        return;
      }
      
      this.dialogRef.close({ 
        amount: newAmount,
        remark: remark
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
